import jThirdPartyList from '@/views/third-party/jThirdPartyList';
// import jThirdPartyDetail from '@/views/third-party/jThirdPartyDetail';

import auth from '@/middleware/auth';
import log from '@/middleware/log';
import admin from '@/middleware/admin';

export default [
  {
    path: '/third-party-connection',
    name: 'jThirdPartyList',
    component: jThirdPartyList,
    meta: {
      title: 'Third Party Connection',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
  // {
  //   path: '/third-party-connection/create',
  //   name: 'jThirdPartyDetail',
  //   component: jThirdPartyDetail,
  //   meta: {
  //     title: 'Third Party Connection',
  //     middleware: [auth, admin, log],
  //     layout: 'jSettingWrapper',
  //   },
  // },
  // {
  //   path: '/third-party-connection/update/:id',
  //   name: 'jThirdPartyDetail',
  //   component: jThirdPartyDetail,
  //   meta: {
  //     title: 'Third Party Connection',
  //     middleware: [auth, admin, log],
  //     layout: 'jSettingWrapper',
  //   },
  // },
];



// WEBPACK FOOTER //
// ./src/router/jRouterThirdParty.js